exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nb-step-svg-wrapper[data-v-0fc63062]{width:100%;display:flex;justify-content:center;align-items:center;border-radius:10px;overflow:hidden;transition:transform .25s ease,filter .25s ease}.nb-step-svg[data-v-0fc63062]{width:100%;max-width:260px;height:auto;aspect-ratio:220/130;display:block}.nb-step-svg-wrapper:hover .nb-step-svg[data-v-0fc63062]{transform:scale(1.02);transition:transform .25s ease}.nb-step-svg-wrapper.is-completed[data-v-0fc63062]{filter:saturate(1.05)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fc63062","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/dashboards/guia-step-svg.vue
// module id = 1065
// module chunks = 0